<template>
  <div>
    <div class="library landscape">
      <transition name="fade">
        <div class="library-glow glowing-mobile" v-show="isMobile"></div>
      </transition>

      <transition name="fade">
        <div class="tocrewroom img-background" v-show="tocrewroom"></div>
      </transition>
      <transition name="fade">
        <div class="tomaproom img-background" v-show="tomaproom"></div>
      </transition>
      <transition name="fade">
        <div class="totoilets img-background" v-show="totoilets"></div>
      </transition>

      <transition name="fade">
        <div class="entry1 img-background" v-show="onEntry1"></div>
      </transition>
      <transition name="fade">
        <div class="entry2 img-background" v-show="onEntry2"></div>
      </transition>
      <transition name="fade">
        <div class="entry3 img-background" v-show="onEntry3"></div>
      </transition>
      <transition name="fade">
        <div class="entry4 img-background" v-show="onEntry4"></div>
      </transition>
      <div
        class="onEntry1"
        @mouseover="
          onEntry1 = true;
          $store.commit('setToPlace', 'read_spaceTale_one');
        "
        @mouseleave="
          onEntry1 = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(1)"
      ></div>
      <div
        class="onEntry2"
        @mouseover="
          onEntry2 = true;
          $store.commit('setToPlace', 'read_spaceTale_two');
        "
        @mouseleave="
          onEntry2 = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(2)"
      ></div>
      <div
        class="onEntry3"
        @mouseover="
          onEntry3 = true;
          $store.commit('setToPlace', 'read_spaceTale_three');
        "
        @mouseleave="
          onEntry3 = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(3)"
      ></div>
      <div
        class="onEntry4"
        @mouseover="
          onEntry4 = true;
          $store.commit('setToPlace', 'read_spaceTale_four');
        "
        @mouseleave="
          onEntry4 = false;
          $store.commit('setToPlace', '...');
        "
        @click="toggleEntry(4)"
      ></div>

      <div v-for="entry in computedEntries" :key="entry.id">
        <LibraryEntry
          @closePopup="toggleEntry(0)"
          :entry="entry"
          v-if="showEntry == entry.id"
        ></LibraryEntry>
      </div>

      <router-link to="/crewroom">
        <div
          class="crewroom"
          :class="{ cursorLeft: tocrewroom }"
          @mouseover="
            tocrewroom = true;
            $store.commit('setToPlace', 'to_crew_room');
          "
          @mouseleave="
            tocrewroom = false;
            $store.commit('setToPlace', '...');
          "
        ></div>
      </router-link>
      <router-link to="/maproom">
        <div
          class="maproom"
          :class="{ cursorLeft: tomaproom }"
          @mouseover="
            tomaproom = true;
            $store.commit('setToPlace', 'backTo_map_room');
          "
          @mouseleave="
            tomaproom = false;
            $store.commit('setToPlace', '...');
          "
        ></div>
      </router-link>
      <router-link to="/toilets">
        <div
          class="toilets"
          :class="{ cursorRight: totoilets }"
          @mouseover="
            totoilets = true;
            $store.commit('setToPlace', 'to_toilets');
          "
          @mouseleave="
            totoilets = false;
            $store.commit('setToPlace', '...');
          "
        ></div>
      </router-link>
      <Portal></Portal>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Portal from "./Portal";
import LibraryEntry from "@/components/utilities/LibraryEntry";
import MainMixin from "@/components/utilities/MainMixin.vue";
import entries from "@/components/utilities/entries.js";
import NotOriented from "@/components/mobile/NotOriented";
export default {
  name: "Library",
  title: "Galactic Library",
  components: {
    Portal,
    LibraryEntry,
    NotOriented,
  },
  computed: {
    computedEntries() {
      return this.entries;
    },
  },
  mixins: [MainMixin],
  data() {
    return {
      tocrewroom: false,
      tomaproom: false,
      totoilets: false,
      entries: entries,
      onEntry1: false,
      onEntry2: false,
      onEntry3: false,
      onEntry4: false,
      showEntry: 0,
    };
  },
  mounted() {
    this.init();
    let newMsg = {
      text:
        "This is the archives of the intergalactic library. Browse through the entries to learn more about why we decided to leave earth.",
      delay: 5000,
    };
    window.addEventListener("keyup", (e) => this.eventClose(e));
    this.$store.commit("setWanerMsg", newMsg);
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
  methods: {
    toggleEntry(id) {
      this.showEntry = id;
      this.$store.commit("focusOnStuff");
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (this.showEntry !== 0) this.toggleEntry(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.library {
  position: absolute;

  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/library.jpg");
  background-size: 100vw 100vh;
  background-color: black;
}

.crewroom {
  position: absolute;
  bottom: 30vh;
  height: 17vh;
  width: 7vw;
  left: 42vw;
}

.library-glow {
  position: absolute;

  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/library-glow.jpg");
  background-size: 100vw 100vh;
}
.tocrewroom {
  background-image: url("../../assets/medias/images/library_tocrewroom.jpg");
}

.maproom {
  position: absolute;
  bottom: 30vh;
  height: 17vh;
  width: 4vw;
  left: 35vw;
}

.tomaproom {
  background-image: url("../../assets/medias/images/library_tomaproom.jpg");
}

.toilets {
  position: absolute;
  bottom: 30vh;
  height: 17vh;
  width: 7vw;
  right: 42vw;
}

.totoilets {
  background-image: url("../../assets/medias/images/library-toToilets.jpg");
}

.onEntry1 {
  position: absolute;
  top: 0;
  height: 53vh;
  width: 16vw;
  right: 0;
}

.onEntry2 {
  position: absolute;
  top: 0;
  height: 53vh;
  width: 9vw;
  right: 13vw;
}

.onEntry3 {
  position: absolute;
  top: 0;
  height: 53vh;
  width: 8vw;
  right: 23vw;
}

.onEntry4 {
  position: absolute;
  top: 0;
  height: 53vh;
  width: 16vw;
  left: 0;
}

.entry1 {
  background-image: url("../../assets/medias/images/library/entry1.jpg");
}

.entry2 {
  background-image: url("../../assets/medias/images/library/entry2.jpg");
}

.entry3 {
  background-image: url("../../assets/medias/images/library/entry3.jpg");
}

.entry4 {
  background-image: url("../../assets/medias/images/library/entry4.jpg");
}
</style>
